<nav>
  <ul class="sidebar-menu-sa">
    <li>
      <a
        routerLink="/project/list"
        class="menu-click"
        routerLinkActive="active"
      >
        <span class="ico-menu-sa">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M10.6666 14V3.33333C10.6666 2.97971 10.5261 2.64057 10.2761 2.39052C10.026 2.14048 9.68687 2 9.33325 2H6.66659C6.31296 2 5.97383 2.14048 5.72378 2.39052C5.47373 2.64057 5.33325 2.97971 5.33325 3.33333V14M2.66659 4.66667H13.3333C14.0696 4.66667 14.6666 5.26362 14.6666 6V12.6667C14.6666 13.403 14.0696 14 13.3333 14H2.66659C1.93021 14 1.33325 13.403 1.33325 12.6667V6C1.33325 5.26362 1.93021 4.66667 2.66659 4.66667Z"
              stroke="black"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </span>
        <span class="menu-text-wrap-sa">
          <span class="menu-text-sa">Projects</span>
        </span>
      </a>
    </li>
    <li>
      <a routerLink="/settings" class="menu-click" routerLinkActive="active">
        <span class="ico-menu-sa"><i class="fa-solid fa-gear"></i></span>
        <span class="menu-text-wrap-sa">
          <span class="menu-text-sa">Settings</span>
        </span>
      </a>
    </li>
    @if (showProjectRealtedMenus) {
    <li>
      <a href="javascript:;" class="active-black">
        <span class="ico-menu-sa">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M10.6666 14V3.33333C10.6666 2.97971 10.5261 2.64057 10.2761 2.39052C10.026 2.14048 9.68687 2 9.33325 2H6.66659C6.31296 2 5.97383 2.14048 5.72378 2.39052C5.47373 2.64057 5.33325 2.97971 5.33325 3.33333V14M2.66659 4.66667H13.3333C14.0696 4.66667 14.6666 5.26362 14.6666 6V12.6667C14.6666 13.403 14.0696 14 13.3333 14H2.66659C1.93021 14 1.33325 13.403 1.33325 12.6667V6C1.33325 5.26362 1.93021 4.66667 2.66659 4.66667Z"
              stroke="black"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </span>
        <span class="menu-text-wrap-sa">
          <span class="menu-text-sa">{{ selectedProjectInfo.name }}</span>
        </span>
      </a>
    </li>
    }
  </ul>

  @if (showProjectRealtedMenus) {
  <ul>
    <menu-items></menu-items>
  </ul>
  }
  <div class="search-results position-relative">
    <div class="search-group">
      <input
        type="text"
        class="form-control"
        placeholder="Search"
        [(ngModel)]="searchText"
        (input)="onSearch()"
      />
      <button type="button" (click)="hideAutocomplete()">
        <i
          class="fa"
          [ngClass]="showAutoComplete ? 'fa-close' : 'fa-search'"
        ></i>
      </button>
      <!-- Add a wrapper div for the dropdown menu -->

      @if(showAutoComplete) {
      <ul
        class="dropdown-menu show position-absolute"
        style="z-index: 9999; max-height: 280px; overflow-y: auto"
      >
        @for (project of projectsToShowInAutoComplete; track $index) {
        <li
          class="dropdown-item"
          (click)="switchProject(project.id, project.name)"
        >
          {{ project.name }}
        </li>
        }
      </ul>
      }
    </div>
    <h6>Recent Projects</h6>
  </div>
  <div class="recent-project-list">
    <ul>
      @for (item of projectsToShowInUI; track item) {
      <li>
        <a
          href="javascript:;"
          (click)="switchProject(item.Project.id, item.Project.name)"
        >
          <span class="ico-menu-sa">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M10.6666 14V3.33333C10.6666 2.97971 10.5261 2.64057 10.2761 2.39052C10.026 2.14048 9.68687 2 9.33325 2H6.66659C6.31296 2 5.97383 2.14048 5.72378 2.39052C5.47373 2.64057 5.33325 2.97971 5.33325 3.33333V14M2.66659 4.66667H13.3333C14.0696 4.66667 14.6666 5.26362 14.6666 6V12.6667C14.6666 13.403 14.0696 14 13.3333 14H2.66659C1.93021 14 1.33325 13.403 1.33325 12.6667V6C1.33325 5.26362 1.93021 4.66667 2.66659 4.66667Z"
                stroke="black"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="menu-text-wrap-sa">
            <span class="menu-text-sa">{{ item.Project.name }}</span>
          </span>
        </a>
      </li>
      }
    </ul>
  </div>
</nav>
